package uz.ferro.erp.feature.customer.model

import kotlinx.serialization.Serializable

@Serializable
class CustomerAddressDto {
    val addressName: String? = null
    val buildingFloorRoom: String? = null
    val addressType: String? = null
    val county: String? = null

    val type: String? = null
    val address2: String? = null
    val address3: String? = null
    val street: String? = null
    val streetNo: String? = null
    val block: String? = null
    val city: String? = null
    val latitude: Double? = null
    val longitude: Double? = null
}